import {EventMarketCap, LiveOddsObject} from "../../../@types/response";
import {getBetfairUrl} from "../../../store/utils/events";
import {LIVE_MARKETS} from "../../../constants/CommonConstants";

export default function OddsComparison({
                                           odds,
                                           refs,
                                           marketId
                                       }: {
    odds: LiveOddsObject[],
    refs?: EventMarketCap,
    marketId: number | string
}) {
    const marketData = LIVE_MARKETS[marketId];
    return (
            <div className='flex justify-between'>
                {odds.sort((a, b) => (!marketData ? 0 : ((marketData.outcomes[a.sign]?.priority || 0) - (marketData.outcomes[b.sign]?.priority || 0)))).map((odd: LiveOddsObject, idx) => {
                    const marketKey = odd.sbv && odd.sbv !== '#' ? `${marketId}@${odd.sbv}` : marketId
                    const marketRef = refs?.[marketKey] ?? refs?.[marketId]
                    const betfairUrl = refs && getBetfairUrl(marketRef?.bMarketId?.toString(), marketRef?.[odd.signId]?.toString())
                    return <div
                            key={idx}
                            data-id={`comparison-odd-${odd.signId}`}
                            data-value={odd.odd.toFixed(2)}
                            className={`p-2 text-center w-1/${odds.length} ${betfairUrl && 'cursor-pointer'}`}
                            onClick={() => {
                                betfairUrl && window.open(betfairUrl, "betfair", "width=925,height=660")
                            }}
                    >
                        {odd.odd.toFixed(2)}
                    </div>
                })}
            </div>
    )
}

